import _ from "lodash";
import * as types from "../actions/table.actions";

/* Table structure so far:
  [name] : {
    loading,
    overlayPosition
  }
*/

const INITIAL_STATE = {
  tables: {}
};

export default function(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case types.RESET_TABLE: {
      const tables = { ...state }.tables;
      tables[action.payload.table] = {};

      return { ...state, tables };
    }

    case types.SET_TABLE_LOADING: {
      const tables = { ...state }.tables;

      if (_.isEmpty(tables[action.payload.table])) {
        tables[action.payload.table] = {};
      }

      tables[action.payload.table].loading = action.payload.loading;

      return { ...state, tables };
    }

    case types.SET_TABLE_ROW_OVERLAY_POSITION: {
      const tables = { ...state }.tables;

      if (_.isEmpty(tables[action.payload.table])) {
        tables[action.payload.table] = {};
      }

      tables[action.payload.table].overlayPosition =
        action.payload.overlayPosition;

      return { ...state, tables };
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/table.reducer.js